export const getConfigurationTitle = (dimensionLabel: string, configuredPluralLabel?: string) => {
    const titleLabel = configuredPluralLabel || dimensionLabel;
    return `Axis Configuration: ${titleLabel}`;
};

export const getOtherGroupLabel = (dimensionLabel: string, configuredPluralLabel?: string) =>
    `Other ${configuredPluralLabel || dimensionLabel}`;

export const DIAGNOSTIC_PAGE_NAME = {
    whitespace: 'whitespace_diagnostic',
    ppa: 'ppa_diagnostic',
} as const;

export const getDiagnosticPageName = (useWhitespacePreview: boolean) =>
    useWhitespacePreview ? DIAGNOSTIC_PAGE_NAME.whitespace : DIAGNOSTIC_PAGE_NAME.ppa;
